/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {migratePrivacyRequest} from '../api'

export const useMutationMigratePrivacyRequest = createReactQueryMutationHook('migratePrivacyRequest', migratePrivacyRequest)
